import Stepper from './Stepper.vue'

export default Stepper
